<div style="display: flex;flex-direction: column; overflow-y: auto; height: 100dvh;">
  <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
    <ion-toolbar class="header-first-toolbar">
      <ion-title class="text-start ion-no-padding title-blue"><span>Create Template </span></ion-title>
      <ion-buttons slot="end" class="ion-no-margin">
        <ion-button class="unfilled-gray-btn" (click)="closeModal()">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <div class="itinerary-model-content" style="display: flex;">
    <!-- Left: Add Template Form -->
    <div class="form-section">
      <app-add-template (formReady)="onFormReady($event)" (submitForm)="onChildSubmit($event)"
        (saveDraft)="onSaveDraft()">
      </app-add-template>
    </div>
    <!-- Right: Preview -->
    <div class="preview-section" *ngIf="templateForm">
      <app-preview-template [previewData]="templateForm.value"></app-preview-template>
    </div>
  </div>
  <!-- Footer Buttons -->
  <div class="ion-padding-horizontal bg-light-gray d-flex justify-content-center itinerary-model-footer">

    <ion-button class="unfilled-blue-btn">
      Reset
    </ion-button>

    <ion-button class="filled-blue-btn" (click)="submitFromParent()" [disabled]="templateForm.invalid">
      Save
    </ion-button>

    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="templateForm.invalid">
      Save & Next
    </ion-button>

  </div>
</div>